import React from 'react';
import {
  makeStyles,
  Table,
  TableCell,
  TableRow,
  Theme,
  Typography,
  createStyles,
} from '@material-ui/core';
import { generateContent } from './endorsementComparisonFunctions';
import { colors } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dynamicCell: {
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        padding: '8px',
      },
    },
    fixedCell: {
      width: '100px',
      [theme.breakpoints.down('sm')]: {
        width: '84px',
        padding: '8px',
      },
    },
    tableCarRentalElement: {
      tableLayout: 'fixed',
      '& tr:first-child': {
        borderTop: 0,
      },
      '& tr:last-child td': {
        borderBottom: 0,
      },
      '& td': {
        borderBottom: `1px dashed ${colors.light_silver}`,
      },
      '& tr td:first-child': {
        borderLeft: 0,
        borderTop: 0,
      },
      '& tr td:last-child': {
        borderRight: 0,
      },
    },
    BC3: {
      fontSize: '11px',
      fontWeight: 400,
      lineHeight: '18px',
    },
  }),
);

export const tableData = [
  ['Colisión o vuelco', '30 días', '15 días', '10 días '],
  ['Robo o hurto', '40 días', '40 días', '30 días'],
  ['Comprensivo', '10 días', '10 días', 'X'],
];

type CarRentalElementProps = {
  endorsementsIndex: Array<number>;
};

const CarRentalElement = ({
  endorsementsIndex,
}: CarRentalElementProps): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="caption">Alquiler de Auto por:</Typography>
      <Table className={classes.tableCarRentalElement}>
        {tableData.map((row) => {
          const [rowName] = row;
          return (
            <TableRow key={rowName}>
              <TableCell className={classes.dynamicCell}>
                <Typography variant="caption">{rowName}</Typography>
              </TableCell>
              {endorsementsIndex.map((endorsementIndex) => (
                <TableCell className={classes.fixedCell} key={endorsementIndex}>
                  <Typography variant="caption">
                    {generateContent(row[endorsementIndex])}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          );
        })}
      </Table>
      <Typography className={classes.BC3}>
        *Aplica sedán compacto para Plan Dorado y sedán compacto o deluxe (SUV o
        4x4) para Platino y Platino Plus.
      </Typography>
    </>
  );
};

export default CarRentalElement;
